import styled from '@emotion/styled';

export const Button = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${(props) => props.theme.colors.primary400};
	padding: 1rem;
	border: none;
	border-radius: ${(props) => props.theme.borderRadius.circle};
	bottom: 3rem;
	right: 3rem;
	cursor: pointer;
	box-shadow: 0 4px 16px rgba(18, 83, 158, 0.32);
	transition:
		background-color ${(props) => props.theme.motion.duration.fast} ${(props) => props.theme.motion.easing.standard},
		transform ${(props) => props.theme.motion.duration.fast} ${(props) => props.theme.motion.easing.standard},
		box-shadow ${(props) => props.theme.motion.duration.fast} ${(props) => props.theme.motion.easing.standard};
	:hover {
		background-color: ${(props) => props.theme.colors.primaryHover};
		transform: translateY(-3px);
		box-shadow: 0 8px 22px rgba(18, 83, 158, 0.38);
	}
	:active {
		background-color: ${(props) => props.theme.colors.primaryActive};
		transform: translateY(-1px);
	}
`;
export const ButtonBox = styled.div`
	position: fixed;
	right: 3rem;
	bottom: 3rem;
	z-index: 12;
	@media (max-width: ${(props) => props.theme.breakpoints.layout}px) {
		right: 2rem;
		bottom: 1.8rem;
	}
`;
